import React, { Component } from 'react';

export default class AlertMessage extends Component {

    onCloseAlert = () => {
        const { onClose } = this.props;
        if (onClose) {
            onClose();
        }
    }

    render() {
        const { show, title, error, success, warning, danger, primary } = this.props.alert;

        if (!show)
            return;

        const { onClose } = this.props;
        let classe = '';
        let message = [];



        if (success)
            classe = 'success';
        if (warning)
            classe = 'warning';
        if (danger)
            classe = 'danger';
        if (primary)
            classe = 'primary';

        if (error) {
            if (error.response) {
                var listMessages = [error.response.data.data];

                if (error.response.status === 403) {
                    classe = 'warning';
                    message.push("Seu perfil de usuário não tem permissão para realizar a operação.");
                } else if (error.response.status === 401) {
                    classe = 'warning';
                    message.push("RU ou senha inválidos.");
                } else if (listMessages && listMessages[0].includes('Validation failed:')) {
                    listMessages[0].split('--').forEach(item => {
                        if (!item.includes('Validation failed:')) {
                            message.push("&#9679;&nbsp;&nbsp;" + item.replace('\r\n', '').replace('\n', '') + '<br/>');
                        }
                    });
                } else {
                    message = listMessages;
                }
            } else {
                message = typeof error.message === 'string' ? [error.message] : error.message;
            }
        }

        return (
            <div className={`alert alert-${classe}`} role="alert">
                {onClose &&
                    <button type="button" className={`close`} style={{ padding: ".2rem .8rem" }} onClick={this.onCloseAlert}>x</button>
                }
                {
                    title &&
                    title.length > 0 &&
                    <strong className="alert-heading">{title}</strong>
                }
                <br />
                {
                    message &&
                    message.map((x, index) => <React.Fragment key={`${index}`}>
                        <br></br>
                        <span dangerouslySetInnerHTML={{ __html: x }}></span>
                    </React.Fragment>)
                }
            </div>
        );
    }
}
